import React from 'react';
import { AirplaneIcon, LocationIcon } from '~svg/index';
const FlightPath = ({ direction }) => {
  return (
    <div className=" position-relative w-100 my-3 flight-path-border">
      <div
        className=" position-absolute m-0"
        style={{
          right: direction === 'rtl' && 30,
          left: direction === 'ltr' && 30,
          top: -10,
          transform: direction === 'rtl' ? 'scaleX(-1)' : '',
        }}
      >
        <AirplaneIcon size={24} color={'#4c54b9'} />
      </div>
      <div
        className=" position-absolute"
        style={{
          top: -18,
          left: direction === 'rtl' && -6,
          right: direction === 'ltr' && -6,
        }}
      >
        <LocationIcon size={18} color={'#3d4a8f'} />
      </div>
      <div
        className="p-1 rounded-pill  position-absolute bg-primary"
        style={{
          height: 8,
          width: 8,
          left: direction === 'ltr' && 0,
          right: direction === 'rtl' && 0,
          top: -3,
          zIndex: 0,
        }}
      ></div>
    </div>
  );
};
export default FlightPath;
